"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";

import { isVaultPagePath } from "@/lib/security/vault-page-security";

/**
 * Hub chrome that must NOT mount on a credential-vault page (vault review M2):
 * the global error reporter, detail/compose modals, the support chat, the
 * header + command palette, Drive preloading, usage tracking and banners. The
 * vault pages render their own minimal frame (`app/vault/layout.tsx`).
 *
 * `usePathname` under `cacheComponents` must sit inside a `<Suspense>` — every
 * call site wraps this in one.
 */
export function HideOnVault({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  if (pathname && isVaultPagePath(pathname)) return null;
  return <>{children}</>;
}
